import { useCallback } from "react";
import loadReCAPTCHAScript from "../../../packages/Recaptcha";
import { useSafeConfigSlice } from "../../packages/config/safe-config";

const useReCaptchaService = () => {
	const { REACT_APP_RECAPTCHA_KEY } = useSafeConfigSlice([
		"REACT_APP_RECAPTCHA_KEY",
	]);

	const findReCaptchaToken = useCallback(async () => {
		await loadReCAPTCHAScript(REACT_APP_RECAPTCHA_KEY);
		await new Promise<void>((resolve, reject) => {
			if (!window.grecaptcha?.enterprise) {
				reject("Google reCAPTCHA Enterprise is not defined.");
			}
			window.grecaptcha.enterprise.ready(resolve);
		});
		return window.grecaptcha.enterprise.execute(REACT_APP_RECAPTCHA_KEY, {
			action: "submit",
		});
	}, [REACT_APP_RECAPTCHA_KEY]);

	return {
		findReCaptchaToken,
	};
};

export default useReCaptchaService;
